var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Forms extends Component {
    constructor() {
        super('Forms', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (typeof jQuery !== 'undefined') {
                jQuery(document).on('gform_page_loaded', (event, x, y) => {
                    scrollTo(0, 0);
                    this.completeSteps();
                });
                this.completeSteps();
            }
            this.success();
        });
    }
    completeSteps() {
        if ($('.gf_page_steps').length > 0) {
            const totalSteps = $('.gf_page_steps .gf_step').length;
            const currentStep = $('.gf_step_active').index() + 1;
            const targetLabel = $('.gform_page').eq(currentStep - 1).find('.gfield:not(.gfield--type-honeypot) .gfield_label').first();
            console.log('targetLabel', targetLabel);
            targetLabel.prepend($.parseHTML(`<span class="step-indicator me-24">${currentStep} / ${totalSteps}</span>`));
            targetLabel.addClass('mb-24 mb-lg-48').removeClass('ps-20');
        }
    }
}
